import { Directive, EventEmitter, ElementRef, Input, Output, OnInit, Renderer, HostListener} from '@angular/core';

@Directive({ selector: '[zx-draggable]' })
export class DraggableDirective  implements OnInit {

    constructor(private el: ElementRef, private rr:Renderer) { }

    private isDragging:boolean = false;
    private _shadowElement:HTMLElement;
    private _dragMode:string = 'NONE';
    private _step = 10;
    private _scale = 1;
    private elementX: number;
    private elementY: number;
    private startX: number;
    private startY: number;
    private endX: number;
    private endY: number;


    @Output("zx-dragged") 
    dragged: EventEmitter<any> = new EventEmitter();
    @Output("zx-dragging") 
    dragging: EventEmitter<any> = new EventEmitter();

    @Input('zx-drag-mode')
    set dragMode(v: string|'MOVING'|'NONE'){
        if(v&&['MOVING','NONE'].indexOf(v.toUpperCase())!=-1)
            this._dragMode = v.toUpperCase();
        else
            this._dragMode = 'NONE';
    }
    get dragMode(): string{
        return this._dragMode;
    }

    @Input('zx-drag-step')
    set step(v: number){ this._step = (v&&v>1)?Math.round(v):1; }
    get step(){ return this._step; }

    @Input('zx-drag-scale')
    set scale(v: number){ this._scale = v?v:1; }
    get scale(){ return this._scale; }
    
    ngOnInit(){ }

    private setBackgroundColor(color){
        if(color) this.el.nativeElement.style.background = color;
    }

    @HostListener('mousedown',['$event']) onMousedown(event) {
        this.isDragging = true;
        this.startX = event.clientX/this.scale;
        this.startY = event.clientY/this.scale;
        this.endX = this.startX;
        this.endY = this.startY;
        this.elementX = event.startX-this.el.nativeElement.offsetLeft;
        this.elementY = event.startY-this.el.nativeElement.offsetTop;
    }

    private get state(){
        return {
           startX: this.endX - this.startX, startY: this.endY - this.startY,
           endX: this.endX, endY: this.endY,
           offsetX: this.endX-this.startX, offsetY: this.endY-this.startY,
        };
    }

    @HostListener('document:mousemove', ['$event']) 
    onMousemove(event){
        if(!this.isDragging) return;

        const x = event.clientX/this.scale;
        const y = event.clientY/this.scale;

        let offsetX = x-this.endX;
        let offsetY = y-this.endY;

        if(Math.abs(offsetX) >= this.step || Math.abs(offsetY) >= this.step){

            offsetX = Math.floor(offsetX/this.step)*this.step;
            offsetY = Math.floor(offsetY/this.step)*this.step;

            this.endX += offsetX;
            this.endY += offsetY;

            // 移动选中的对象
            if(this._dragMode == 'MOVING'){
                this.el.nativeElement.style.left = x - this.elementX + "px";
                this.el.nativeElement.style.top  = y - this.elementY + "px";
            }
            this.dragging.emit({ offsetX: offsetX, offsetY: offsetY });
        }
    }

    @HostListener('document:mouseup',['$event']) 
    onMouseup() {
        if(!this.isDragging) return;
        this.isDragging = false;

        this.dragged.emit(this.state);
    }

}